export const INSTALLERS_DEFAULT_QUERY = {
  _pagina: '1',
  _num_x_pagina: '10',
}

export const INSTALLERS_TABLE_COLUMNS = [
  { field: 'nombre', align: 'left', width: 200 },
  { field: 'cif', align: 'left', width: 120 },
  { field: 'email', align: 'left', width: 240 },
  { field: 'telefono', align: 'left', width: 120 },
  { field: 'poblacion', align: 'left', width: 120 },
  { field: 'empresa_ca_id', align: 'left', width: 200, comboId: 'cod_zona_zeus' },
  { field: 'validado', align: 'left', width: '120', type: 'boolean' },
]

export const INSTALLERS_TABLE_ACTIONS = [
  {
    field: 'actions',
    width: 120,
    align: 'center',
    sorting: false,
    disableClick: true,
  },
]
